var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { loanResponseStatus } from '@repo/shared/types';
import { baseCommon } from './steps-common-data.mock';
export var loanProcessStep7 = __assign(__assign({}, baseCommon), { data: {
        limitId: 1721299100,
        status: loanResponseStatus.enum.REJECTED,
        providerRequest: 'requested',
        preLimitId: 1721299100,
        loanId: 1721299103,
        rejectionReason: 'Nie odnaleziono firmy z numerem NIP: 8885411259',
        rejectionDescription: [
            'Posiadasz opóźnienia w płatnościach wobec PragmaGO.',
            'Podane przez Ciebie dane nie zgadzają się z danymi w BIK.',
        ],
    } });
